import { PERMISSION_ACTIONS } from './permissionActions';
import { PERMISSION_SUBJECTS } from './permissionSubjects';

const NEOVARSITY_MANAGEMENT_SIDEBAR_DATA = [
  {
    header: 'NEOVARSITY MANAGEMENT',
    tabs: [
      {
        tabName: 'Project Management',
        to: '/neovarsity/projects/',
        subject: PERMISSION_SUBJECTS.capstoneSubmission,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
      {
        tabName: 'Sync user activities',
        to: '/neovarsity/sync-user-activities',
        subject: PERMISSION_SUBJECTS.capstoneSubmission,
        permissions: [PERMISSION_ACTIONS.manage, PERMISSION_ACTIONS.read],
      },
    ],
  },
];

export default NEOVARSITY_MANAGEMENT_SIDEBAR_DATA;
